import { Component, Input } from '@angular/core';
import { AFormat } from '@df/interfaces';
import { IExercise } from '@df/interfaces/exercise';
import { KATEX_FORMAT } from '@app/app.constants';

@Component({
    selector: 'app-exercise-preview-calculation',
    templateUrl: './exercise-preview-calculation.component.html',
    styleUrls: ['../../../../_pipes/exercise-format.pipe.scss', './exercise-preview-calculation.component.scss']
})
export class ExercisePreviewCalculationComponent {
    @Input() exercise: any;
    @Input() card_format: string;
    @Input() index: number;
    @Input() mainCardView = false;

    AFormat = AFormat;

    constructor() {}

    isKatexFormat(exercise: IExercise): boolean {
        return exercise.format_type === KATEX_FORMAT;
    }
}
